module.exports = __webpack_public_path__ + "img/yw2.dd9bbd8d.png";